import { render, staticRenderFns } from "./PrintReturnReceipt.vue?vue&type=template&id=246a0bbd"
import script from "./PrintReturnReceipt.vue?vue&type=script&lang=js"
export * from "./PrintReturnReceipt.vue?vue&type=script&lang=js"
import style0 from "./PrintReturnReceipt.vue?vue&type=style&index=0&id=246a0bbd&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports